import { render, staticRenderFns } from "./VuesticBreadcrumbs.vue?vue&type=template&id=51ab09e0&"
import script from "./VuesticBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./VuesticBreadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./VuesticBreadcrumbs.vue?vue&type=style&index=0&id=51ab09e0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports